"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseFormatNumber = exports.createFormatNumber = void 0;
const currency_js_1 = __importDefault(require("currency.js"));
const react_1 = require("react");
const context_1 = require("../context/context");
const curry_1 = require("../utils/curry");
const map_options_1 = require("../utils/map-options");
function createFormatNumber(localizeConfigs) {
    return (locale, value, options) => {
        var _a;
        const precision = (_a = options === null || options === void 0 ? void 0 : options.precision) !== null && _a !== void 0 ? _a : 0;
        const formatOptions = { ...(0, map_options_1._mapOptions)(localizeConfigs[locale].number), precision };
        return (0, currency_js_1.default)(value, { precision }).format(formatOptions);
    };
}
exports.createFormatNumber = createFormatNumber;
function createUseFormatNumber(localizeConfigs) {
    return () => {
        const locale = (0, context_1._useLocalizeContext)();
        return (0, react_1.useMemo)(() => (0, curry_1._curry)(createFormatNumber(localizeConfigs))(locale), [locale]);
    };
}
exports.createUseFormatNumber = createUseFormatNumber;
